import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.medium`
    flex-direction: column;
    width: 190px;
    z-index: 1;
    padding: 0 20px 0 0;
  `}
`;
